// extracted by mini-css-extract-plugin
module.exports = {"Page":"ManagerReviews_Page__1u7kQ","TableCard":"ManagerReviews_TableCard__xAErn"};